import {Component} from '@angular/core';
import {AuthService} from "./shared/services/auth.service";
import {StorageService} from "./shared/services/storage.service";
import {EventBusService} from "./shared/event/eventBus.service";
import {Subscription} from "rxjs";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
    title = 'bootDash';
    isLoggedIn = false;
    eventBusSub?: Subscription;


    constructor(private authService: AuthService, private storageService: StorageService, private eventBusService: EventBusService) {
    }

    ngOnInit(): void {
        this.isLoggedIn = this.storageService.isLoggedIn();
        if(this.isLoggedIn) {
            console.log("storage service ", this.storageService.getUser());
        }
        this.eventBusSub = this.eventBusService.on('logout', () => {
            this.logout();
        });
    }
    // test
    logout(): void {
        this.authService.logout().subscribe({
            next: res => {
                console.log(res);
                this.storageService.clean();
                window.location.reload();
            },
            error: err => {
                console.log(err);
            }
        });
    }
}
